import { createStore } from "vuex";
import AppModule from "./app";
import AuthModule from "./auth";
import LessonModule from "./lesson";
import ModalModule from "./modal";
import ParentModule from "./parent";
import StudentRoomModule from "./room/student";
import TeacherRoomModule from "./room/teacher";
import SpinModule from "./spin";
import TeacherModule from "./teacher";
import ClassTeachingModule from "./teaching/class";
import StudentTeachingModule from "./teaching/student";
import TeacherTeachingModule from "./teaching/teacher";
import WhiteboardModule from "./whiteboard";
import CallingModule from "./calling";
import TeamsModule from "./teams";
import DeviceModule from "./device";
import RealtimeSettingsModule from "./realtime-settings";
import annotationV2Module from "./annotation-v2";
import SpacePresenceModule from "./space-presence";

const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: AppModule,
    auth: AuthModule,
    spin: SpinModule,
    parent: ParentModule,
    teacher: TeacherModule,
    teacherRoom: TeacherRoomModule,
    studentRoom: StudentRoomModule,
    realtimeSettings: RealtimeSettingsModule,
    lesson: LessonModule,
    classTeaching: ClassTeachingModule,
    studentTeaching: StudentTeachingModule,
    teacherTeaching: TeacherTeachingModule,
    modal: ModalModule,
    whiteboard: WhiteboardModule,
    calling: CallingModule,
    teams: TeamsModule,
    device: DeviceModule,
    annotationV2: annotationV2Module,
    spacePresence: SpacePresenceModule,
  },
  devtools: true,
});

export {
  store,
  AppModule,
  AuthModule,
  SpinModule,
  ParentModule,
  TeacherModule,
  TeacherRoomModule,
  StudentRoomModule,
  RealtimeSettingsModule,
  LessonModule,
  ClassTeachingModule,
  StudentTeachingModule,
  TeacherTeachingModule,
  ModalModule,
  WhiteboardModule,
  CallingModule,
  TeamsModule,
  SpacePresenceModule,
};
